<template>
  <section-modal
    modal-id="section-modal"
    :form_fields="getFormFields"
    :ok_title="isEdit ? $t('generals.edit') : $t('generals.create')"
    :def_form_obj="defObj"
    :modal_title="isEdit ? $t('objects.edit_entryway') : $t('objects.add_new_entryway')"
    @formSubmit="saveSection"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import sectionModal from '@/components/validatedFormModal.vue'

export default {
  components: {
    sectionModal,
  },
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    defObj: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      form_fields: [
        {
          component_name: 'b-form-input',
          obj_name: 'title',
          label: this.$t('generals.name'),
          validation_rules: 'required',
          placeholder: this.$t('generals.name'),
        },
        {
          component_name: 'v-select',
          obj_name: 'order',
          label: this.$t('objects.put_in_plice'),
          placeholder: this.$t('objects.position'),
          props: {
            options: this.GET_SECTIONS,
            label: 'title',
            reduce: option => option.sort,
          },
        },
      ],
    }
  },
  computed: {
    ...mapGetters('sections', ['GET_SECTIONS']),
    getFormFields() {
      if (this.isEdit) {
        return [
          {
            component_name: 'b-form-input',
            obj_name: 'title',
            label: this.$t('generals.name'),
            validation_rules: 'required',
            placeholder: this.$t('generals.name'),
          },
          {
            component_name: 'v-select',
            obj_name: 'order',
            label: this.$t('objects.put_after'),
            placeholder: this.$t('objects.position'),
            props: {
              options: this.GET_SECTIONS,
              label: 'title',
              reduce: option => option.sort,
            },
          },
        ]
      }
      return [
        {
          component_name: 'b-form-input',
          obj_name: 'title',
          label: this.$t('generals.name'),
          validation_rules: 'required',
          placeholder: this.$t('generals.name'),
        },
      ]
    },
  },
  methods: {
    ...mapActions('sections', ['ADD_SECTION', 'EDIT_SECTION']),
    saveSection(section) {
      if (this.isEdit) {
        const { order, sort, ...rest } = section
        // let new_order = 0
        // if (sort === order) {
        //   new_order = sort
        // } else {
        //   new_order = order + 1
        // }
        console.log(order)
        console.log(sort)
        const reqData = {
          sort: order,
          ...rest,
        }
        console.log(reqData)
        this.EDIT_SECTION(reqData).then(() => {
          this.$emit('saved')
          this.defObj.title = ''
          this.$bvModal.hide('section-modal')
          this.$_successToast(this.$t('generals.changed'))
        }).catch(() => {
          this.$_errorToast(this.$t('generals.error'))
        })
      } else {
        const { sort, ...rest } = section
        const reqData = {
          ...rest,
        }
        console.log(reqData)
        this.ADD_SECTION(reqData).then(() => {
          this.$emit('saved')
          this.defObj.title = ''
          this.$bvModal.hide('section-modal')
          this.$_successToast(this.$t('generals.added'))
        }).catch(() => {
          this.$_errorToast(this.$t('generals.error'))
        })
      }
    },
  },
}
</script>

<style>

</style>
